module.exports = __webpack_public_path__ + "assets/50d62ab59e2bfa581288b03d2b1990ce.png";